import { useQuery } from '@tanstack/react-query';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import {
  braintreeClientTokenAtom,
  generateBraintreeClientToken,
} from '@features/Payments';

export const useGenerateBraintreeClientToken = ({
  userFields,
  merchantAccountId,
}: {
  userFields: { email?: string; id?: number | string };
  merchantAccountId?: string | null;
}): string | null => {
  const [braintreeClientToken, setBraintreeClientToken] = useAtom(
    braintreeClientTokenAtom,
  );

  const isEnabled =
    !!userFields.id &&
    !!userFields.email &&
    !!merchantAccountId &&
    braintreeClientToken === '';

  const { data, error } = useQuery({
    queryKey: [
      'braintreeClientToken',
      userFields.id,
      userFields.email,
      merchantAccountId,
    ] as const,
    queryFn: async () =>
      await generateBraintreeClientToken({
        customerEmail: userFields.email!,
        customerId: userFields.id!.toString(),
        merchantAccountId: merchantAccountId!,
      }),
    enabled: isEnabled,
    gcTime: 1000 * 60 * 60 * 24, // 1 day,
    staleTime: 1000 * 60 * 60 * 24, // 1 day
  });

  useEffect(() => {
    if (error) {
      setBraintreeClientToken('');
    } else if (data) {
      setBraintreeClientToken(data);
    }
  }, [data, error, setBraintreeClientToken]);

  return braintreeClientToken;
};
